import classNames from 'classnames';
import { format, isValid, parseISO } from 'date-fns';
import React, { useMemo } from 'react';
import CurrencyFormat from 'react-currency-format';
import { GerenciadorPrecos } from '../../@types/GerenciadorPrecos';
import PercentageIndicator from '../PercentageIndicator/PercentageIndicator';
import styles from './ChangedCostsDetails.module.scss';

type ChangedCostsDetailsProps = Pick<GerenciadorPrecos.RowData, 'costDetails' | 'hasCostChanged'>;

const currencyProps = {
  displayType: 'text',
  decimalScale: 2,
  prefix: 'R$ ',
  fixedDecimalScale: true,
  decimalSeparator: ',',
} as const;

const ChangedCostsDetails = ({ costDetails, hasCostChanged }: ChangedCostsDetailsProps) => {
  const formatDate = (dateString: string | undefined): string | null => {
    if (!dateString) return null;
    try {
      const date = parseISO(dateString);
      return isValid(date) ? format(date, 'dd/MM/yyyy') : '-';
    } catch {
      return null;
    }
  };

  const formatedDate = useMemo(() => formatDate(costDetails?.costUpdatedAt), [costDetails?.costUpdatedAt]);

  if (!costDetails) return null;
  return (
    <div className={styles['wrapper']}>
      <h4 className={styles['title']}>Detalhe dos custos</h4>
      <ul className={styles['list']}>
        <li className={styles['list__item']}>
          <span>Custo atual</span>
          {costDetails?.productCost ? (
            <strong>
              <CurrencyFormat value={costDetails.productCost} {...currencyProps} />
            </strong>
          ) : (
            <span>--</span>
          )}
        </li>

        <li
          className={classNames(styles['list__item'], {
            [styles['is-older-than-seven-days']]: hasCostChanged,
          })}
        >
          <span>Data do custo atual</span>
          {formatedDate ? <strong>{formatedDate}</strong> : <span>-</span>}
        </li>

        <li className={styles['list__item']}>
          <span>Custo anterior</span>
          {costDetails?.lastProductCost ? (
            <strong>
              <CurrencyFormat value={costDetails?.lastProductCost} {...currencyProps} />
            </strong>
          ) : (
            <span>--</span>
          )}
        </li>

        <li className={styles['list__item']}>
          <span>Variação</span>
          {costDetails?.costChangePercentage ? <PercentageIndicator value={costDetails?.costChangePercentage} suffix="%" invert /> : <span>--</span>}
        </li>
      </ul>
    </div>
  );
};

export default ChangedCostsDetails;
